var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBold24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M6 4h5.98c3.8 0 5.2 1.45 5.2 3.83 0 2.07-1.1 3.36-3.02 3.78v.05c2.2.17 3.84 1.17 3.84 3.84 0 2.7-1.81 4.5-6.24 4.5H6V4Zm5.46 13.73c2.42 0 3.48-.82 3.48-2.5 0-1.93-1.58-2.26-3.36-2.26H8.96v4.76h2.5Zm-.38-6.96c2.05 0 3.27-.85 3.27-2.48 0-1.55-1-2.02-2.68-2.02h-2.7v4.5h2.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold24);
export default __webpack_public_path__ + "static/media/bold_24.0f48144eb38741326ebb65a9cbd27485.svg";
export { ForwardRef as ReactComponent };